import { createAction } from "@reduxjs/toolkit";

export const newCustomerCleanup = createAction("newCustomerCleanup");
